export default __webpack_public_path__ + "images/HV.a943132.png";